// ====== 配置区域 ======
const SHOP_DOMAIN = 'uat-dutties-p.myshopify.com'; // 替换成你的店铺域名
const STOREFRONT_TOKEN = 'aebf0d570c253eecabf45be9b4c52bf6'; // Storefront API Token
const API_URL = `https://${SHOP_DOMAIN}/api/2025-10/graphql.json`;

// 搜索输入框 & 下拉容器
const searchInput = document.querySelector('.t4s-mini-search__input'); // Kalles 默认搜索框 id


const dropdown = document.createElement('div');
dropdown.className = 'predictive-results';
dropdown.style.position = 'fixed';
dropdown.style.zIndex = 9999;
dropdown.style.background = '#fff';
dropdown.style.border = '0px solid #ddd';
dropdown.style.width = '80%';
dropdown.style.maxHeight = '230px';
dropdown.style.overflowY = 'auto';
dropdown.style.display = 'none';
// dropdown.style.boxShadow= '0 3px 10px 0 rgb(129 129 129 / 20%)';

// const observer = new MutationObserver(() => {
//   const el = document.querySelector(".t4s-mini-search__listKey");
//   if (el) {
//     observer.disconnect();
//     searchList();
//   }
// });

// const observer = new MutationObserver(() => {
//   const els = document.querySelectorAll(".t4s-mini-search__listKey");

//   if (els.length > 0) {
//     observer.disconnect();

//     els.forEach(el => {
//       searchList(el); // 建议把当前元素传进去
//     });
//   }
// });


const handled = new WeakSet();

const observer = new MutationObserver(() => {
  const els = document.querySelectorAll(".t4s-mini-search__listKey");

  els.forEach(el => {
    if (!handled.has(el)) {
      handled.add(el);
      searchList(el);
    }
  });
});

// 监听整个 body（Shopify 这种很常见）
observer.observe(document.body, {
  childList: true,
  subtree: true
});

observer.observe(document.body, { childList: true, subtree: true });

function searchList1() {


  fetch("https://app.dutties.com/api/search", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ date: "2026-01-14" }) // 可选
  })
    .then(res => res.json())
    .then(data => {

      // console.log(data)

      // 过滤逻辑
      const filtered = [];
      const seen = new Set();

      const container = document.querySelector(".t4s-mini-search__listKey");
    

      data.top_searches.forEach(item => {
        const term = item.search_query?.trim().toLowerCase();

        // 跳过无效或重复项、前两个 tag
        if (!term || term === "1_bid ntt4tag" || term === "2_bid ntt4tag") return;
        if (seen.has(term)) return;

        seen.add(term);
        filtered.push(item);

        
      
      });

      const finalList = filtered.slice(0, 14);
      container.innerHTML = ""; // 清空旧内容

      // 遍历返回的热门搜索词
      finalList.forEach((term, index) => {
    
      
          const li = document.createElement("li");
          li.className = "";
          li.style = "flex: 0 0 calc(50% - 10px);font-size: 13px;position: relative; ";

          // 构造链接
          const a = document.createElement("a");
          const span = document.createElement("span");
          a.setAttribute("data-key", term.search_query);
          a.href = `/search?type=product&options%5Bunavailable_products%5D=&options%5Bprefix%5D=last&q=${encodeURIComponent(term.search_query)}`;

          a.textContent = term.search_query;

          if (index === 0 || index === 1) {
            a.style= "color: #aa0033;display: block;";
            span.style="font-size: 12px;color: #aa0033;border-radius: 7px;position: absolute;top: 0px;padding-left:3px;font-weight: 800;"
            span.textContent="🔥";
          }

          // a.style= () ? ""  : '';

          // 

          li.appendChild(a);
          if (index === 0 || index === 1) {
          a.appendChild(span);
          }
          container.appendChild(li);
        
      
      });
    })
    .catch(err => console.error(err));
}


function searchList(el) {
  const container = el;
  
  // const container = document.querySelector(".t4s-mini-search__listKey");
  const cacheKey = "topSearchesCache";
  const cacheTimeKey = "topSearchesCacheTime";
  const cacheDuration = 480 * 60 * 1000; // 10分钟

  // 先检查缓存
  const cachedData = localStorage.getItem(cacheKey);
  const cachedTime = localStorage.getItem(cacheTimeKey);

  if (cachedData && cachedTime && (Date.now() - cachedTime < cacheDuration)) {
    renderList(JSON.parse(cachedData), container);
    // console.log(container);
    return;
  }

  // 如果没有缓存或缓存过期，则发请求
  fetch("https://app.dutties.com/api/search", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ date: "2026-01-14" })
  })
    .then(res => res.json())
    .then(data => {
      localStorage.setItem(cacheKey, JSON.stringify(data));
      localStorage.setItem(cacheTimeKey, Date.now());
      renderList(data, container);
    })
    .catch(err => console.error(err));
}

// 渲染函数
function renderList(data, container) {

  
  const filtered = [];
  const seen = new Set();

  data.top_searches.forEach(item => {
    const term = item.search_query?.trim().toLowerCase();
    if (!term || term === "1_bid ntt4tag" || term === "2_bid ntt4tag") return;
    if (seen.has(term)) return;
    seen.add(term);
    filtered.push(item);
  });

  const finalList = filtered.slice(0, 10);
  container.innerHTML = "";

  finalList.forEach((term, index) => {
    const li = document.createElement("li");
    // li.style = "flex: 0 0 calc(50% - 10px);font-size: 13px;position: relative;";
    li.style = "font-size: 13px;display: inline-flex;align-items: center;padding: 4px 12px;font-size: 14px;color: #333;background: #f2f5f9;border-radius: 999px;cursor: pointer;transition: all 0.2s ease;border: 1px solid #e1e4e8;";

    const a = document.createElement("a");
    const span = document.createElement("span");

    a.setAttribute("data-key", term.search_query);
    a.href = `/search?type=product&options%5Bunavailable_products%5D=&options%5Bprefix%5D=last&q=${encodeURIComponent(term.search_query)}`;
    a.textContent = term.search_query;

    if (index === 0 || index === 1 || index === 2) {
      a.style = "color: #333;display: block;";
      // span.style = "font-size: 12px;color: #aa0033;border-radius: 7px;position: absolute;top: 0px;padding-left:3px;font-weight: 800;";
      span.style = "font-size: 12px;color: #333;border-radius: 7px;top: 0px;padding-left:3px;font-weight: 800;";
      span.textContent = "🔥";
    }

    li.appendChild(a);
    if (index === 0 || index === 1 || index === 2) {
      a.appendChild(span);
    }

    container.appendChild(li);
  });
}

// searchInput.parentNode.appendChild(dropdown);

// ====== 通用 GraphQL 请求函数 ======
async function storefrontQuery(query, variables = {}) {
  const res = await fetch(API_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Shopify-Storefront-Access-Token': STOREFRONT_TOKEN,
    },
    body: JSON.stringify({ query, variables }),
  });
  const json = await res.json();
  if (json.errors) console.error('Storefront API Error:', json.errors);
  return json.data;
}

// ====== 渲染下拉搜索结果 ======
function renderDropdown(products) {
  if (!products || products.length === 0) {
    dropdown.style.display = 'none';
    return;
  }

  dropdown.innerHTML = products
    .map(
      (p) => `
    <div class="search-item" style="display:flex;align-items:center;padding:8px 10px;border-bottom:1px solid #e1e4e8;cursor:pointer;">
      
      <span>${p}</span>
    </div>`
    )
    .join('');

  dropdown.style.display = 'block';

  // 点击跳转
  dropdown.querySelectorAll('.search-item').forEach((el, index) => {
   const spanText = el.querySelector('span').textContent; // 获取 span 文本
    console.log(spanText);

    el.addEventListener('click', () => {
      // 使用 spanText 作为搜索关键字
      window.location.href = `/search?resources%5Boptions%5D%5Bfields%5D=title%2Cproduct_type%2Cvariants.title%2Cvendor%2Cvariants.sku%2Ctag&q=${encodeURIComponent(spanText)}`;
    });
  });
}

function renderDropdown2(categories, inputValue) {
  // console.log(categories, inputValue);
  // const dropdown = document.getElementById('dropdown'); // 下拉容器
  // if (!dropdown) return;

  if (!categories || Object.keys(categories).length === 0 || !inputValue || Object.keys(inputValue).length <=2) {
    dropdown.style.display = 'none';
    dropdown.innerHTML = '';
    return;
  }

  const matches = [];

  // 遍历 categories 找匹配
  for (const [category, wordsMap] of Object.entries(categories)) {
    for (const [word, tags] of Object.entries(wordsMap)) {
      if (word.toLowerCase().includes(inputValue.toLowerCase())) {
        matches.push({ word, tags });
      }
    }
  }
  // console.log(matches);

  // if (matches.length === 0) {
  //   dropdown.style.display = 'none';
  //   dropdown.innerHTML = '';
  //   return;
  // }

  // 安全转义防止 XSS
  const escapeHtml = (unsafe) =>
    unsafe
      .replaceAll('&', '&amp;')
      .replaceAll('<', '&lt;')
      .replaceAll('>', '&gt;')
      .replaceAll('"', '&quot;')
      .replaceAll("'", '&#039;');

  // 防止正则注入
  const escapeRegExp = (string) => string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

  // 创建匹配部分高亮的正则
  const safeInput = escapeRegExp(inputValue);
  const regex = new RegExp(`(${safeInput})`, 'gi');


  var firstQuery = '';
  // ⚙️ 一开始只展示前5个
  const initialLimit = 10;
  const showingAll = dropdown.dataset.showingAll === 'true';

  const displayList = showingAll ? matches : matches.slice(0, initialLimit);

  


  // 渲染下拉列表
  dropdown.innerHTML = displayList
    .map((item, index) => {
      if(index === 0) {
        firstQuery = escapeHtml(item.word);
      }
      const safeWord = escapeHtml(item.word);
      const highlighted = safeWord.replace(regex, `<span class="highlight">$1</span>`);
      return `
        <div class="search-item" style="font-weight: 500;display:flex;align-items:center;padding:8px 10px 8px 16px;border-bottom:1px solid #f1f4f8;cursor:pointer;">
        <svg class="t4s-btn-op0" viewBox="0 0 18 19" width="16"><path fill-rule="evenodd" clip-rule="evenodd" d="M11.03 11.68A5.784 5.784 0 112.85 3.5a5.784 5.784 0 018.18 8.18zm.26 1.12a6.78 6.78 0 11.72-.7l5.4 5.4a.5.5 0 11-.71.7l-5.41-5.4z" fill="currentColor"></path></svg>
          <span style="margin-left: 5px;">${highlighted}</span>
        </div>`;
    })
    .join('');
    const keysContainer = document.querySelector(".t4s-mini-search__keys");
    keysContainer.style.maxHeight = '230px';

    // if (matches.length > initialLimit) {
    //   const toggleText = showingAll ? 'Ver más opciones  >' : 'Ver más opciones  >';
    //   dropdown.innerHTML += `
    //     <div class="search-more" style="text-align:center;padding:6px 10px;color:#787878;cursor:pointer;font-size:13px;">
    //       ${toggleText}
    //     </div>`;
    // }

    // t4s-mini-search__keys

  dropdown.style.display = 'block';

  // 点击跳转
  dropdown.querySelectorAll('.search-item').forEach((el, index) => {
    const { tags } = matches[index]; // 对应的 tags
    const query = encodeURIComponent(tags.join(' '));
    el.addEventListener('click', () => {
      window.location.href = `/search?resources%5Boptions%5D%5Bfields%5D=title%2Cproduct_type%2Cvariants.title%2Cvendor%2Cvariants.sku%2Ctag&q=${query}`;
    });
  });

  const moreBtn = dropdown.querySelector('.search-more');
    if (moreBtn) {
      moreBtn.addEventListener('click', () => {
        window.location.href = `/search?resources%5Boptions%5D%5Bfields%5D=title%2Cproduct_type%2Cvariants.title%2Cvendor%2Cvariants.sku%2Ctag&q=${firstQuery}`;
        // dropdown.dataset.showingAll = showingAll ? 'false' : 'true';
        // if(showingAll) {
        //   dropdown.style.maxHeight = '190px';
        // } else {
        //   dropdown.style.maxHeight = '400px';
        // }
        // renderDropdown2(categories, inputValue); // 重新渲染
      });
    }

  
}

// ====== 输入监听 & API 调用 ======
let timer;

document.addEventListener('input', function(e) {

  // 判断事件源是弹框里的输入框
  if (e.target && e.target.matches('.t4s-mini-search__input')) {
    
    e.target.parentNode.appendChild(dropdown);
    const query = e.target.value.trim();
   
    const dataEl = document.getElementById('search-data');
    const categories = JSON.parse(dataEl.textContent);
    
   
    // console.log(categories);
    renderDropdown2(categories, query);
    // renderDropdown2(categories);
    // 输出: ["Poleras", "Mujer"]

    // console.log(query);
    // clearTimeout(timer);
    // console.log('弹框输入变化:', e.target.value);
    // 防刷：延迟 300ms 调用
    // timer = setTimeout(async () => {
    //   const gql = `
    //     query predictiveSearch($query: String!) {
    //       search(query: $query, first: 10) {
    //         edges {
    //           node {
    //               ... on Product {
    //               title
    //               handle
    //               tags
    //               }
    //           }
    //           }
    //       }
    //     }
    //   `;
    //   const data = await storefrontQuery(gql, { query });
    //   // console.log(data);
    //   // 提取所有以 P/p 开头的 tag
    //   const allPTags = data.search.edges
    //     .flatMap(edge => edge.node.tags)            // 展开每个 node 的 tags
    //     .filter(tag => tag.toLowerCase().startsWith(query)); // 只保留以 p 开头的标签

    //   // 去重
    //   const uniquePTags = [...new Set(allPTags)];

    //   console.log(uniquePTags);
    //   // const products = data?.predictiveSearch?.products || [];
    //   renderDropdown(uniquePTags);
    // }, 300);

  //   searchInput.addEventListener('focus', () => {
  //   if (!dropdown.contains(e.target) && e.target !== searchInput) {
  //     dropdown.style.display = 'block';
  //   }
  // });

  }
});

// 点击空白隐藏下拉
// document.addEventListener('click', (e) => {
//  if (
//     !dropdown.contains(e.target) &&
//     e.target !== searchInput &&
//     !document.querySelector('#top-searches')?.contains(e.target)
//   ) {
//     dropdown.style.display = 'none';
//   }
// });

document.addEventListener('click', (e) => {
  // 如果下拉不存在或已经隐藏，则不处理
  if (!dropdown || dropdown.style.display === 'none') return;

  const isClickInsideDropdown = dropdown.contains(e.target);
  const isClickSearchInput = e.target === searchInput;
  const isClickTopSearches = document.querySelector('.t4s-mini-search__listKey')?.contains(e.target);
  const isClickMoreBtn = e.target.closest('.search-more'); // ✅ 新增：点击“查看更多”按钮不隐藏

  // 只有在点击区域不属于这些元素时才隐藏
  if (!isClickInsideDropdown && !isClickSearchInput && !isClickTopSearches && !isClickMoreBtn) {
    dropdown.style.display = 'none';
    dropdown.dataset.showingAll = 'false'; // 收起状态重置
  }
});


